<div class="flex flex-1 h-full flex-col">
  <div class="font-semibold text-sm text-navy-600 pt-6 px-8 pb-10 w-full flex justify-between items-center box-border">
    {{ (model.id ? 'Edit' : 'Add') + ' Daily Activity' }}

    @if (model.id) {
      <div
        (click)="toggleCompletion()"
        class="mark-complete"
        [ngClass]="{ completed: model.completed, 'disable-element': disableCompletion }"
      >
        {{ model.completed ? 'Completed' : 'Mark Complete' }}
      </div>
    }
  </div>
  <div class="border-b border-solid border-navy-300 -mt-2"></div>

  <ng-scrollbar class="std-scrollbar" appearance="native" orientation="vertical">
    <div class="mb-5 mt-2 pt-1 h-full horizontal-spacing scrollable-content">
      <form class="h-full" name="ngForm" #form="ngForm" role="form">
        <app-floating-input
          required
          [(ngModel)]="model.title"
          name="title"
          label="Title or short description"
          placeholder="Title or short description"
        ></app-floating-input>

        <!--          leave optionValue empty to use the whole object as the value -->
        <app-dropdown
          optionLabel="title"
          optionValue="id"
          name="project"
          label="Projects"
          placeholder="Projects"
          [options]="possibleProjects"
          [(ngModel)]="model.project_id"
          (ngModelChange)="onProjectChange($event)"
          required
        >
          <ng-template #selectedContent let-option>
            <div
              class="dropdown-item"
              [ngClass]="{ 'text-navy-600 font-semibold text-co': option.id === noRelatedProject.id }"
            >
              {{ option.title | titlecase }}
            </div>
          </ng-template>
          <ng-template #optionContent let-option>
            <div class="dropdown-item" [ngClass]="{ 'text-navy-600 font-semibold': option.id === noRelatedProject.id }">
              {{ option.title | titlecase }}
            </div>
            @if (areSimpleProjectsLoading$ | async) {
              <div class="pt-2 pb-0.5">Loading ...</div>
            }
          </ng-template>
        </app-dropdown>

        <app-input-calendar
          required
          name="start_date"
          [showIcon]="true"
          [(date)]="model.start_date"
          [minStartDate]="selectedProject?.start_date"
          [maxDate]="model?.end_date"
          placeholder="Start Date"
        ></app-input-calendar>

        <app-input-calendar
          required
          name="end_date"
          placeholder="Due Date"
          [(date)]="model.end_date"
          [minStartDate]="model?.start_date || selectedProject?.start_date"
          [showIcon]="true"
        ></app-input-calendar>

        <app-floating-textarea
          class="pr-0.5 pl-0.5 h-full"
          label="Additional Details (optional)"
          placeholder="Additional Details (optional)"
          name="details"
          [(ngModel)]="model.description"
          [autoResize]="false"
        ></app-floating-textarea>
      </form>
    </div>
  </ng-scrollbar>

  <div class="flex items-center justify-between ml-auto mb-7 mr-5 mt-4 pl-8 pr-4 gap-4">
    @if (model?.id) {
      <div (click)="deleteActivity()" class="delete-button">Delete</div>
    }
    <div
      (click)="submit()"
      [ngClass]="{ 'bg-yellow-500': !model?.id, 'bg-blue-700': !!model?.id }"
      class="rounded text-color-white py-1 px-10 font-semibold text-sm cursor-pointer"
    >
      {{ !!model?.id ? 'Update' : 'Save' }}
    </div>
  </div>
  <div></div>
</div>
